import { render, staticRenderFns } from "./mobileList.vue?vue&type=template&id=0d6b25ba&scoped=true&"
import script from "./mobileList.vue?vue&type=script&lang=js&"
export * from "./mobileList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6b25ba",
  null
  
)

export default component.exports